<script setup lang="ts">
import { getRewardTypeIcon, getRewardTypeLabel } from '@/components/rewards/utils/rewardTypeDisplay'

const props = defineProps<{
  rewardType?: { slug: string; name: string }
}>()

const { t } = useI18n()

const icon = computed(() => (props.rewardType ? getRewardTypeIcon(props.rewardType) : 'HeroGiftIconOutline'))

const label = computed(() => (props.rewardType ? getRewardTypeLabel(props.rewardType, t) : '-'))
</script>

<template>
  <BaseChip v-if="rewardType" :icon="icon" :text="label" color="gray" />
</template>
